import React from 'react';
import { useSearchHistoryStore } from '@components/SearchBar/SearchHistory/useSearchHistoryStore';
import { SearchHistoryCard } from './SearchHistoryCard';

export const RecentSearches = () => {
  const history = useSearchHistoryStore();

  return (
    <>
      {history.length > 0 && (
        <div className="mb-6 flex flex-col gap-4 px-4 md:px-6">
          <h3 className="font-title text-title-l font-medium">Recent Searches</h3>
          <div className="grid grid-cols-1 gap-2 md:grid-cols-5 md:gap-5">
            {history.map(entity => {
              return <SearchHistoryCard key={entity.id} entity={entity} />;
            })}
          </div>
        </div>
      )}
    </>
  );
};
